import ApiService from '@/services/api.service'

const AuthService = {
  userLogin: async function (email, password) {
    const formData = new FormData()
    formData.append('email', email)
    formData.append('password', password)

    try {
      const response= await ApiService.post('/user/login', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      return this.userInfoStore(response)
    } catch (error) {
      console.log(error)

      throw error
    }
  },

  userRegister: async function (role, name, jobTitle, email, password) {
    const formData = new FormData()
    formData.append('role', role)
    formData.append('name', name)
    formData.append('jobTitle', jobTitle)
    formData.append('email', email)
    formData.append('password', password)

    try {
      return await ApiService.post('/user/register', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
    } catch (error) {
      console.log(error)

      throw error
    }
  },

  userLogout: async function () {
    document.cookie = 'login_session_id=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    document.cookie = 'login_session_id=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=fuchsjobs.de;';
    localStorage.removeItem('loginStatus');
    localStorage.removeItem('userInfo');
  },

  userInfoStore: async function (response) {
    const userInfo = {
      email: response.data.email,
      name: response.data.name,
      role: response.data.role,
      uuid: response.data.uuid,
      avatar: response.data.avatar,
    };

    localStorage.setItem('loginStatus', 'success');
    localStorage.setItem('userInfo', JSON.stringify(userInfo));

    return userInfo
  },

  userFetchStatus: async function () {
      return ApiService.get('/user/fetch')
  },

  userVerify: async function (sessionId) {
    try {
      const response =  await ApiService.post('/user/verify', {
        'sessionId' : sessionId
      });

      return this.userInfoStore(response)
    } catch (error) {
      console.log(error)

      throw error
    }
  },

  userReVerify: async function (email, sessionId) {
    try {
      return await ApiService.post('/user/re-verify', {
        'email': email,
        'sessionId' : sessionId
      });
    } catch (error) {
      console.log(error)

      throw error
    }
  },

  userResetPasswordSession: async function (email) {
    try {
      return await ApiService.post('/user/reset-password/session', {
        'email' : email
      });
    } catch (error) {
      console.log(error)

      throw error
    }
  },

  userResetPassword: async function (sessionId, password) {
    try {
      const response =  await ApiService.post('/user/reset-password', {
        'sessionId' : sessionId,
        'password' : password,
      });

      return this.userInfoStore(response)
    } catch (error) {
      console.log(error)

      throw error
    }
  },

  userGoogleAuth: async function (code) {
    try {
      return await ApiService.get(`/user/auth/google/fetch?code=${code}`);
    } catch (error) {
      console.log(error)

      throw error
    }
  },

  userGoogleLogin: async function (name, jobTitle, token) {
    try {
      return await ApiService.post('/user/auth/google/login', {
        'name': name,
        'jobTitle': jobTitle,
        'token': token
      });
    } catch (error) {
      console.log(error)

      throw error
    }
  },
}

export default AuthService
